import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Mail = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Mail({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6.5C2 5.39543 2.89543 4.5 4 4.5H20C21.1046 4.5 22 5.39543 22 6.5V16.5C22 18.1569 20.6569 19.5 19 19.5H5C3.34315 19.5 2 18.1569 2 16.5V6.5ZM19.2286 6H4.7717L12.0002 12.0237L19.2286 6ZM3.5 6.89281V16.5C3.5 17.3284 4.17157 18 5 18H19C19.8284 18 20.5 17.3284 20.5 16.5V6.89307L12.8004 13.3094C12.3368 13.6957 11.6635 13.6957 11.1999 13.3094L3.5 6.89281Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'mail-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Mail;
